export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8 text-sm">
        <div>
          <div className="font-bold text-gold mb-2">MAPTRIUM™</div>
          <p className="text-white/70 leading-relaxed">
            Production data-mapping tool from Atlas Geo Technologies. Upload, validate, export, and deliver without touching a GIS desktop.
          </p>
        </div>
        <div>
          <div className="font-bold text-gold mb-2">Product</div>
          <ul className="space-y-1 text-white/70">
            <li>Five export formats</li>
            <li>11-step QA validation</li>
            <li>DOCX reports with methodology</li>
            <li>Secure cloud delivery</li>
          </ul>
        </div>
        <div>
          <div className="font-bold text-gold mb-2">Company</div>
          <ul className="space-y-1 text-white/70">
            <li>Atlas Geo Technologies LLC</li>
            <li>SDVOSB · VOSB · Small Business</li>
            <li><a className="hover:text-gold" href="mailto:info@atlasgeo.ai">info@atlasgeo.ai</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between text-xs text-white/50">
          <div>© {new Date().getFullYear()} Atlas Geo Technologies LLC</div>
          <div
            title={
              "Three independent versions make up MAPTRIUM Desktop:\n\n" +
              "• Classic UI (this web app): the React interface you see now\n" +
              "• Desktop Shell: the Electron installer version (bottom-right of the window)\n" +
              "• Backend Engine: the dispatcher + workers that run jobs\n\n" +
              "They are released on separate cadences. All three are shown on Settings > Status."
            }
            style={{ cursor: 'help' }}
          >
            MAPTRIUM Classic UI · v{__CLASSIC_UI_VERSION__ || "0.1.0"}
          </div>
        </div>
      </div>
    </footer>
  );
}

// __CLASSIC_UI_VERSION__ is injected at build time by vite.config.ts via
// `define` from atlas-studio/package.json "version". Keeps the display in
// sync with every release — no more hard-coded "v0.1" that drifts.
